/**
 * @name Eglise EMIA
 * @author Mr. Josia Yvan
 * @description System API and Management System Software ~ Developed By Mr. Josia Yvan
 * @copyright ©2025 ― Mr. Josia Yvan. All rights reserved.
 * @version v0.0.1
 *
 */
import { LoadingOutlined, LockOutlined, PhoneOutlined } from '@ant-design/icons';
import {
  Alert, Button, Divider, Form, Input
} from 'antd';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Logo from '../assets/images/logo.png';
import useTimeout from '../hooks/useTimeout';
import ApiService from '../utils/apiService';
import { setSessionUserAndToken } from '../utils/authentication';

function Login() {
  window.document.title = 'Eglise EMIA — Login';
  const [loading, setLoading] = useState(false);
  const [errMsg, setErrMsg] = useState('');

  // timeout callback
  const [timeout] = useTimeout(() => {
    setErrMsg('');
  }, 2000);

  timeout();

  // function to handle user login
  const onFinish = async (values) => {
    try {
      setLoading(true);
      const response = await ApiService.post('/auth/signin', values);
      if (response?.result_code === 0) {
        if (response?.result?.data?.xrole === 'USER_ROLE') { setErrMsg('Sorry! You are not authorized to access this application'); return; }
        setSessionUserAndToken(response?.result?.data, response?.access_token, response?.refresh_token);
        window.location.href = '/main/accueil';
      } else {
        setErrMsg('Sorry! Something went wrong. App server error');
      }
      setLoading(false);
    } catch (error) {
      setErrMsg(error?.response?.data?.result?.error || 'Sorry! Something went wrong. App server error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className='flex flex-col h-screen items-center justify-center'>
      <div className='w-[90%] md:w-[450px]'>
        <Link to='/'>
          <img
            className='h-[65px] mx-auto'
            alt='beach-resort-logo'
            src={Logo}
          />
        </Link>

        <Divider className='!mb-10'>LOGIN AUTHORIZED USER ONLY</Divider>
        {errMsg && <Alert message={errMsg} type='error' className='!text-center' />}

        <Form
          name='beach-resort-login'
          className='login-form mt-5'
          initialValues={{ remember: true }}
          onFinish={onFinish}
          size='large'
        >
          <Form.Item
            name='firstname'
            rules={[{
              // type: 'firstname',
              required: true,
              message: 'Please input your firstname!'
            }]}
          >
            <Input
              prefix={<PhoneOutlined className='site-form-item-icon mr-2' />}
              placeholder='Enter here your firstname'
            />
          </Form.Item>

          <Form.Item
            name='password'
            rules={[{
              required: true,
              message: 'Please input your Password!'
            }]}
          >
            <Input.Password
              prefix={<LockOutlined className='site-form-item-icon mr-2' />}
              placeholder='Enter here your Password'
              type='password'
            />
          </Form.Item>

          {/* FORM SUBMIT BUTTON */}
          <Form.Item>
            <Button
              className='login-form-button mt-5'
              disabled={loading}
              loading={loading}
              htmlType='submit'
              type='primary'
              block
            >
              {loading ? <LoadingOutlined /> : 'Login'}
            </Button>
          </Form.Item>
        </Form>
      </div>
    </section>
  );
}

export default React.memo(Login);
